export function base64EncodeUnicode(str: string): string {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      const code = Number.parseInt('0x' + p1, 16);
      return String.fromCharCode(code);
    })
  );
}
